"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDataUploadContainer = SimpleDataUploadContainer;
const React = __importStar(require("react"));
const FileUpload = __importStar(require("../file-upload"));
const Xlsx = __importStar(require("xlsx"));
function SimpleDataUploadContainer({ onParsed, children }) {
    return (React.createElement(FileUpload.FileUploadContainer, { onFileUploaded: createParseFile(onParsed), children: children, accept: "text/csv,.csv,.xlsx" }));
}
function createParseFile(onParsed) {
    return (file) => {
        const fileFormat = file.name.split(".").reverse()[0].toLowerCase();
        switch (fileFormat) {
            case "csv":
                parseCsv(file, onParsed);
                break;
            case "xlsx":
                parseXlsx(file, onParsed);
                break;
            default:
                throw new Error("Unsupported format");
        }
    };
}
function parseXlsx(file, onParsed) {
    const fileReader = new FileReader();
    fileReader.onload = evt => {
        const textResult = evt.target.result;
        const workbook = Xlsx.read(textResult, { type: "binary" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = Xlsx.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
        const parsedContent = json.map((r) => r.map((c) => c.toString()));
        onParsed(parsedContent);
    };
    fileReader.readAsBinaryString(file);
}
function parseCsv(file, onParsed) {
    const fileReader = new FileReader();
    fileReader.onload = evt => {
        const textResult = evt.target.result;
        const parsed = parseCsvText(textResult);
        onParsed(parsed);
    };
    fileReader.readAsText(file);
}
function parseCsvText(text) {
    const newLineRegex = /\r?\n/;
    const rows = text.split(newLineRegex);
    return rows
        .filter(row => row && row.length > 0) // Filter empty rows. E.G last CRLF would create and empty row
        .map(parseRow);
}
function parseRow(row) {
    return row.split(/[,;]/).map(val => {
        // biome-ignore lint: -
        return (val && val.replace(/\"/g, "")) || "";
    });
}
//# sourceMappingURL=simple-data-upload-container.js.map